import { CircleX, Minus, Plus } from "lucide-react";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CalenderIcon from "assets/images/icons/calendarPrimary.svg";
import { Calendar } from "primereact/calendar";
import {
  convertToUTCDateTimeString,
  formatDateTime,
} from "components/common/Utils";
import { showAlert } from "store/reducers/alertReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  addRechargeToCustomerWallet,
  getCustomerDetails,
} from "store/actions/customerSlice";

const WalletRecharge = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const calendarRef = useRef(null);

  const { isLoading } = useSelector((state) => state.Customers);

  const [amount, setAmount] = useState(0);
  const [datetime12h, setDateTime12h] = useState(null);

  const handleIncrement = () => setAmount((prev) => prev + 1);

  const handleDecrement = () => setAmount((prev) => (prev > 0 ? prev - 1 : 0));

  const handleInputChange = (e) => {
    const value = e.target.value;
    const number = parseInt(value, 10);

    if (!isNaN(number) && number >= 1) {
      setAmount(number);
    } else if (value === "") {
      setAmount(1);
    }
  };

  const handleRechargeClick = () => {
    if (!datetime12h) {
      dispatch(
        showAlert({
          text: t("Please select date & time"),
          type: "error",
        })
      );
      return;
    } else if (!amount || amount == 0) {
      dispatch(
        showAlert({
          text: t("Please enter amount"),
          type: "error",
        })
      );
      return;
    }
    const payload = {
      userIds: [id],
      amount,
      expiryDate: convertToUTCDateTimeString(datetime12h),
    };

    dispatch(addRechargeToCustomerWallet(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(getCustomerDetails({ id }));
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <div className="common_card_inner wallet_recharge">
      <h2 className="fs_20">{t("Recharge")}</h2>
      <div className="mt-4">
        <p className="fs_12 text_gray">{t("Expiry Date")}</p>
        <div
          className="date_wrapper g_between c_p"
          onClick={() => calendarRef.current?.show()}
        >
          <Calendar
            id="calendar-12h"
            value={datetime12h}
            onChange={(e) => setDateTime12h(e.value)}
            showTime
            hourFormat="12"
            ref={calendarRef}
            inputStyle={{
              position: "absolute",
              width: 0,
              height: 0,
              padding: 0,
              margin: 0,
              border: "none",
              opacity: 0,
              pointerEvents: "none",
            }}
            panelStyle={{ zIndex: 9999 }}
            minDate={new Date()}
          />
          <div className="d-flex w-100 gap-2">
            <img
              src={CalenderIcon}
              alt="icon"
              width={18}
              height={18}
              className="mb-1"
            />
            <span className="text_black">
              {formatDateTime(datetime12h)}
              {/* Feb 10, 12:00pm */}
            </span>
          </div>
          {datetime12h && (
            <button
              type="button"
              className="transparent_btn"
              onClick={(e) => {
                e.stopPropagation();
                setDateTime12h(null);
              }}
            >
              <CircleX className="text_danger" size={18} />
            </button>
          )}
        </div>
        <div className="buttons">
          <button className="bg_primary text-white" onClick={handleIncrement}>
            <Plus />
          </button>
          <input
            type="number"
            className="count-input"
            value={amount}
            onChange={handleInputChange}
            min="1"
          />
          <button className="bg_danger text-white" onClick={handleDecrement}>
            <Minus />
          </button>
        </div>
        <button
          className="main_btn w-100"
          disabled={isLoading}
          onClick={handleRechargeClick}
        >
          {t("Recharge")}
        </button>
      </div>
    </div>
  );
};

export default WalletRecharge;
